var React = require('react');

function EventAppIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15.617 0H1.444C0.647 0 0 0.647 0 1.444V27.345C0 28.143 0.647 28.789 1.444 28.789H15.617C16.414 28.789 17.061 28.143 17.061 27.345V1.444C17.061 0.647 16.414 0 15.617 0ZM15.995 27.345C15.995 27.553 15.826 27.722 15.618 27.722H1.445C1.237 27.722 1.068 27.553 1.068 27.345V22.395H15.996V27.345H15.995ZM15.995 21.328H1.067V4.286H15.995V21.328ZM15.995 3.22H1.067V1.444C1.067 1.236 1.236 1.066 1.444 1.066H15.617C15.825 1.066 15.994 1.236 15.994 1.444V3.22H15.995Z","fill":"#555555","key":0}),React.createElement("path",{"d":"M6.93188 24.5229H10.1309V25.5889H6.93188V24.5229Z","fill":"#555555","key":1})]);
}

EventAppIcon.defaultProps = {"width":"18","height":"29","viewBox":"0 0 18 29","fill":"none"};

module.exports = EventAppIcon;

EventAppIcon.default = EventAppIcon;
